export type ListboxKeyEvent = {
    key: string;
    altKey: boolean;
    ctrlKey: boolean;
    metaKey: boolean;
    shiftKey: boolean;
};

const MOVE_KEYS = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'];

/** Arrow, Home, and End move inside a listbox. Modified chords stay with the browser. */
export function listboxMoveKey(event: ListboxKeyEvent): string | null {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return null;
    return MOVE_KEYS.indexOf(event.key) >= 0 ? event.key : null;
}

/** Next index for a move key. Stays on the first or last option instead of wrapping. */
export function nextOptionIndex(current: number, length: number, key: string): number | null {
    if (length <= 0) return null;
    const index = current < 0 || current >= length ? 0 : current;
    switch (key) {
        case 'ArrowDown':
        case 'ArrowRight':
            return Math.min(index + 1, length - 1);
        case 'ArrowUp':
        case 'ArrowLeft':
            return Math.max(index - 1, 0);
        case 'Home':
            return 0;
        case 'End':
            return length - 1;
        default:
            return null;
    }
}

/**
 * The option that owns the one tab stop.
 * A cursor left behind by the arrow keys wins while that option is still in the list; otherwise the selected option; otherwise the first visible option.
 */
export function activeOptionIndex(values: readonly number[], selected: number, cursor: number | null): number {
    if (values.length === 0) return -1;
    if (cursor !== null) {
        const cursorIndex = values.indexOf(cursor);
        if (cursorIndex >= 0) return cursorIndex;
    }
    const selectedIndex = values.indexOf(selected);
    return selectedIndex >= 0 ? selectedIndex : 0;
}
